import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGrandPremiere from "./sections/TheGrandPremiere";
import KitchenSpecialties from "./sections/KitchenSpecialties";
import UrbanStories from "./sections/UrbanStories";
import TheSashaLandonExperience from "./sections/TheSashaLandonExperience";
import VisionaryPartnerships from "./sections/VisionaryPartnerships";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGrandPremiere />
      <KitchenSpecialties />
      <UrbanStories />
      <TheSashaLandonExperience />
      <VisionaryPartnerships />
      <Footer />
    </div>;
}